/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
  ClinicalTrialContextState,
  ClinicalTrialContextFetchAction,
  ClinicalTrialContextFetchSuccessAction,
} from './clinicalTrialContext.types';
import { createSliceHook, makeActionCreator, createSelector } from '../helpers';

export const initialState: ClinicalTrialContextState = {
  loading: false,
  error: undefined,
  data: null,
  flatAllLabels: {},
  flatVisits: {},
  groupedLabels: {},
};

const { act, actReq, actResolve, actReject } =
  makeActionCreator<ClinicalTrialContextState>();

export const clinicalTrialContextSlice = createSlice({
  name: 'clinicalTrialContext',
  initialState,
  reducers: {
    fetchClinicalTrialContext:
      actReq<ClinicalTrialContextFetchAction['payload']>(),
    fetchClinicalTrialContextSuccess: act<
      ClinicalTrialContextFetchSuccessAction['payload']
    >(({ data, flatVisits, flatAllLabels, groupedLabels }) => ({
      data,
      flatVisits,
      flatAllLabels,
      groupedLabels,
      loading: false,
    })),
    fetchClinicalTrialContextFailure: actReject(),
    fetchClinicalTrialContextRestore: act<ClinicalTrialContextState>(s => s),
    clearData: state => {
      state.data = null;
    },
  },

  selectors: {
    selectFlatAllLabels: state => state.flatAllLabels,
    selectFlatVisits: state => state.flatVisits,
    selectGroupedLabels: state => state.groupedLabels,
    selectConfig: state => state.data?.configuration,
  },
});

export const {
  fetchClinicalTrialContext,
  fetchClinicalTrialContextSuccess,
  fetchClinicalTrialContextFailure,
} = clinicalTrialContextSlice.actions;

export const actions = {
  ...clinicalTrialContextSlice.actions,
};

export const useClinicalTrialContextSlice = createSliceHook(
  clinicalTrialContextSlice.name,
  actions,
  initialState
);

export const {
  selectFlatAllLabels,
  selectFlatVisits,
  selectGroupedLabels,
  selectConfig,
} = clinicalTrialContextSlice.selectors;

export const selectClinicalTrialContextState = createSelector(
  'clinicalTrialContext'
);
